export const CardIcon = ({ ...props }) => {
  return (
    <svg
      width="59"
      height="52"
      viewBox="0 0 59 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_25_24110)">
        <path
          d="M54.634 25.4004H48.9858V19.1561C48.9858 18.9665 48.8653 18.7894 48.6865 18.7241L40.7804 15.8133C40.6763 15.7745 40.5656 15.7745 40.4713 15.8133L32.5652 18.7241C32.3864 18.7899 32.2659 18.9598 32.2659 19.1561V27.3571C32.2659 32.2832 35.7406 36.5858 40.5367 37.5833C40.5656 37.5931 40.6022 37.5931 40.631 37.5931C40.6599 37.5931 40.6964 37.5931 40.7253 37.5833C45.5209 36.5759 48.9961 32.2807 48.9961 27.3571V26.3202H54.6443C54.8494 27.3276 55.7406 28.0802 56.7982 28.0802C58.015 28.0802 59.0005 27.0821 59.0005 25.866C59.0005 24.6499 58.0078 23.6518 56.7982 23.6518C55.7282 23.6471 54.8494 24.4018 54.6345 25.3998L54.634 25.4004ZM48.0781 27.3597C48.0781 31.8243 44.9485 35.7213 40.6217 36.6728C36.2944 35.7208 33.1653 31.8145 33.1653 27.3597V19.4762L40.6217 16.7352L48.0781 19.4762V25.4004H43.9945C43.741 25.4004 43.5453 25.6065 43.5453 25.852C43.5453 26.0975 43.7503 26.3036 43.9945 26.3036H48.0781V27.3597ZM58.0897 25.8618C58.0897 26.5781 57.5101 27.1707 56.7879 27.1707C56.0656 27.1707 55.4861 26.588 55.4861 25.8618C55.4861 25.1357 56.0656 24.553 56.7879 24.553C57.5101 24.553 58.0897 25.1455 58.0897 25.8618Z"
          fill="url(#paint0_linear_25_24110)"
        />
        <path
          d="M0.514154 51.0967H0.448729C0.195272 51.0967 -0.000488281 51.3028 -0.000488281 51.5483C-0.000488281 51.7938 0.204545 52 0.448729 52H0.514154C0.767612 52 0.963372 51.7938 0.963372 51.5483C0.963372 51.3028 0.758339 51.0967 0.514154 51.0967Z"
          fill="url(#paint1_linear_25_24110)"
        />
        <path
          d="M52.1355 51.0967H46.4776C46.7022 50.7569 46.8423 50.354 46.8423 49.9194V41.388C46.8423 41.1331 46.6372 40.9363 46.3931 40.9363C46.1489 40.9363 45.9438 41.1425 45.9438 41.388V49.9194C45.9438 50.57 45.4199 51.0967 44.7631 51.0967H40.716C40.9406 50.7569 41.0808 50.354 41.0808 49.9194V43.3183C41.0808 43.0635 40.8757 42.8667 40.6315 42.8667C40.3874 42.8667 40.1823 43.0728 40.1823 43.3183V49.9194C40.1823 50.57 39.6584 51.0967 39.0114 51.0967H3.7282C3.08116 51.0967 2.55725 50.57 2.55725 49.9194L2.55982 40.4096C2.55982 39.759 3.08374 39.2323 3.73078 39.2323H31.4092C31.6626 39.2323 31.8584 39.0262 31.8584 38.7807C31.8584 38.5352 31.6534 38.329 31.4092 38.329L3.72872 38.3264C3.08168 38.3264 2.55776 37.7997 2.55776 37.1393L2.56034 27.6294C2.56034 26.9789 3.08425 26.4522 3.73129 26.4522H26.6599C26.9134 26.4522 27.1092 26.246 27.1092 26.0005C27.1092 25.755 26.9041 25.5489 26.6599 25.5489H3.72872C3.08168 25.5489 2.55776 25.0221 2.55776 24.3716L2.56034 14.8591C2.56034 14.2086 3.08425 13.6819 3.73129 13.6819H31.2309C31.4844 13.6819 31.6802 13.4757 31.6802 13.2302C31.6802 12.9847 31.4751 12.7786 31.2309 12.7786H3.7282C3.08116 12.7786 2.55725 12.2518 2.55725 11.5915L2.55982 2.09144C2.55982 1.44091 3.08374 0.904321 3.73078 0.904321H38.9841C39.6311 0.904321 40.155 1.43106 40.155 2.09144V9.77557C40.155 10.0304 40.3601 10.2272 40.6042 10.2272C40.8484 10.2272 41.0535 10.0211 41.0535 9.77557V2.09092C41.0535 1.64912 40.9231 1.24357 40.6887 0.903803H44.7358C45.3828 0.903803 45.9165 1.43055 45.9165 2.09092V11.5909C45.9165 11.666 45.9068 11.7318 45.897 11.7971C45.8511 12.0421 46.0103 12.2876 46.2617 12.3337C46.5054 12.3798 46.7496 12.2197 46.7954 11.967C46.815 11.8458 46.834 11.7121 46.834 11.5811V2.0904C46.834 0.93229 45.897 0 44.7549 0H3.7282C2.5861 0 1.64902 0.94213 1.64902 2.0904V11.5904C1.64902 12.2581 1.96791 12.8433 2.44597 13.2292C1.95812 13.6151 1.64902 14.2003 1.64902 14.8679V24.3706C1.64902 25.0382 1.96791 25.6235 2.44597 25.9995C1.96791 26.3853 1.64902 26.9706 1.64902 27.6284V37.131C1.64902 37.7986 1.96791 38.3839 2.44597 38.7698C1.95812 39.1556 1.64902 39.7409 1.64902 40.4085V49.9184C1.64902 50.3504 1.77936 50.7559 2.01376 51.0957H1.65881C1.40535 51.0957 1.20959 51.3018 1.20959 51.5473C1.20959 51.7928 1.41463 51.999 1.65881 51.999H52.135C52.3885 51.999 52.5842 51.7928 52.5842 51.5473C52.5842 51.3018 52.3885 51.0957 52.135 51.0957H52.1355V51.0967Z"
          fill="url(#paint2_linear_25_24110)"
        />
        <path
          d="M56.4216 51.0967H54.089C53.8355 51.0967 53.6398 51.3028 53.6398 51.5483C53.6398 51.7938 53.8448 52 54.089 52H56.4216C56.6751 52 56.8708 51.7938 56.8708 51.5483C56.8708 51.3028 56.673 51.0967 56.4216 51.0967Z"
          fill="url(#paint3_linear_25_24110)"
        />
        <path
          d="M58.539 51.0967H58.2953C58.0418 51.0967 57.8461 51.3028 57.8461 51.5483C57.8461 51.7938 58.0511 52 58.2953 52H58.539C58.7924 52 58.9882 51.7938 58.9882 51.5483C58.9882 51.3028 58.7924 51.0967 58.539 51.0967Z"
          fill="url(#paint4_linear_25_24110)"
        />
        <path
          d="M14.8463 43.3594C14.3682 43.3594 13.919 43.5489 13.5713 43.8861C13.2333 44.2259 13.0474 44.6775 13.0474 45.168C13.0474 46.1661 13.8541 46.9767 14.8463 46.9767H17.5241C18.0022 46.9767 18.4612 46.7871 18.7991 46.4499C19.137 46.1101 19.323 45.6585 19.323 45.168C19.323 44.1699 18.5163 43.3594 17.5241 43.3594H14.8463ZM18.4132 45.1659C18.4132 45.4016 18.319 45.6274 18.15 45.7973C17.981 45.9672 17.7564 46.062 17.522 46.062H14.8442C14.3564 46.062 13.9556 45.6663 13.9556 45.1685C13.9556 44.9235 14.0499 44.7071 14.209 44.5372C14.378 44.3673 14.6026 44.2725 14.837 44.2725H17.5148C18.0197 44.2725 18.4132 44.678 18.4132 45.1659Z"
          fill="url(#paint5_linear_25_24110)"
        />
        <path
          d="M7.09935 43.3594C6.62128 43.3594 6.16227 43.5489 5.82433 43.8861C5.48639 44.2259 5.30042 44.6775 5.30042 45.168C5.30042 46.1661 6.10715 46.9767 7.09935 46.9767H9.77714C10.2552 46.9767 10.7142 46.7871 11.0522 46.4499C11.3901 46.1101 11.5761 45.6585 11.5761 45.168C11.5761 44.1699 10.7693 43.3594 9.77714 43.3594H7.09935ZM10.6684 45.1659C10.6684 45.4016 10.5741 45.6274 10.4051 45.7973C10.2361 45.9672 10.0115 46.062 9.77714 46.062H7.09935C6.61149 46.062 6.2107 45.6663 6.2107 45.1685C6.2107 44.9235 6.30497 44.7071 6.47394 44.5372C6.64034 44.3673 6.86495 44.2725 7.09935 44.2725H9.77714C10.2748 44.2725 10.6684 44.678 10.6684 45.1659Z"
          fill="url(#paint6_linear_25_24110)"
        />
        <path
          d="M36.3984 43.8211V46.5134C36.3984 46.7682 36.6035 46.965 36.8477 46.965C37.0918 46.965 37.2969 46.7589 37.2969 46.5134V43.8211C37.2969 43.5663 37.0918 43.3695 36.8477 43.3695C36.604 43.3596 36.3984 43.5663 36.3984 43.8211Z"
          fill="url(#paint7_linear_25_24110)"
        />
        <path
          d="M33.6815 43.0845V47.2456C33.6815 47.5004 33.8866 47.6972 34.1307 47.6972C34.3749 47.6972 34.58 47.4911 34.58 47.2456V43.0845C34.58 42.8296 34.3749 42.6328 34.1307 42.6328C33.8866 42.6328 33.6815 42.8296 33.6815 43.0845Z"
          fill="url(#paint8_linear_25_24110)"
        />
        <path
          d="M31.4236 42.6338C31.1701 42.6338 30.9744 42.8399 30.9744 43.0854V47.2466C30.9744 47.5014 31.1794 47.6982 31.4236 47.6982C31.6678 47.6982 31.8728 47.4921 31.8728 47.2466V43.0854C31.8728 42.8306 31.6678 42.6338 31.4236 42.6338Z"
          fill="url(#paint9_linear_25_24110)"
        />
        <path
          d="M28.2482 43.0845V47.2456C28.2482 47.5004 28.4532 47.6972 28.6974 47.6972C28.9416 47.6972 29.1466 47.4911 29.1466 47.2456V43.0845C29.1466 42.8296 28.9416 42.6328 28.6974 42.6328C28.4532 42.6328 28.2482 42.8296 28.2482 43.0845Z"
          fill="url(#paint10_linear_25_24110)"
        />
        <path
          d="M25.5317 43.0845V47.2456C25.5317 47.5004 25.7368 47.6972 25.981 47.6972C26.2251 47.6972 26.4302 47.4911 26.4302 47.2456V43.0845C26.4302 42.8296 26.2251 42.6328 25.981 42.6328C25.7368 42.6328 25.5317 42.8296 25.5317 43.0845Z"
          fill="url(#paint11_linear_25_24110)"
        />
        <path
          d="M22.8148 43.8211V46.5134C22.8148 46.7682 23.0199 46.965 23.264 46.965C23.5082 46.965 23.7133 46.7589 23.7133 46.5134V43.8211C23.7133 43.5663 23.5082 43.3695 23.264 43.3695C23.0126 43.3596 22.8148 43.5663 22.8148 43.8211Z"
          fill="url(#paint12_linear_25_24110)"
        />
        <path
          d="M14.8463 30.5889C14.3682 30.5889 13.9092 30.7784 13.5713 31.1156C13.2333 31.4554 13.0474 31.907 13.0474 32.3975C13.0474 33.3956 13.8541 34.2061 14.8463 34.2061H17.5241C18.0022 34.2061 18.4612 34.0166 18.7991 33.6794C19.137 33.3396 19.323 32.888 19.323 32.3975C19.323 31.3994 18.5163 30.5889 17.5241 30.5889H14.8463ZM18.4132 32.3877C18.4132 32.6233 18.319 32.8492 18.15 33.019C17.981 33.1889 17.7564 33.2837 17.522 33.2837H14.8442C14.3564 33.2837 13.9556 32.888 13.9556 32.3903C13.9556 32.1453 14.0499 31.9288 14.209 31.7589C14.378 31.589 14.6026 31.4942 14.837 31.4942H17.5148C18.0197 31.5015 18.4132 31.8972 18.4132 32.3877Z"
          fill="url(#paint13_linear_25_24110)"
        />
        <path
          d="M7.09935 30.5889C6.62128 30.5889 6.16227 30.7784 5.82433 31.1156C5.48639 31.4554 5.30042 31.907 5.30042 32.3975C5.30042 33.3956 6.10715 34.2061 7.09935 34.2061H9.77714C10.2552 34.2061 10.7142 34.0166 11.0522 33.6794C11.3901 33.3396 11.5761 32.888 11.5761 32.3975C11.5761 31.3994 10.7693 30.5889 9.77714 30.5889H7.09935ZM10.6684 32.3877C10.6684 32.6233 10.5741 32.8492 10.4051 33.019C10.2361 33.1889 10.0115 33.2837 9.77714 33.2837L7.09935 33.2811C6.61149 33.2811 6.2107 32.8854 6.2107 32.3877C6.2107 32.1427 6.30497 31.9262 6.47394 31.7563C6.64292 31.5864 6.86753 31.4916 7.10192 31.4916H9.77971C10.2748 31.5015 10.6684 31.8972 10.6684 32.3877Z"
          fill="url(#paint14_linear_25_24110)"
        />
        <path
          d="M28.2482 33.743V34.4785C28.2482 34.7333 28.4532 34.9301 28.6974 34.9301C28.9416 34.9301 29.1466 34.724 29.1466 34.4785V33.743C29.1466 33.4882 28.9416 33.2913 28.6974 33.2913C28.4537 33.2815 28.2482 33.4902 28.2482 33.743Z"
          fill="url(#paint15_linear_25_24110)"
        />
        <path
          d="M25.5317 30.3071V34.4683C25.5317 34.7231 25.7368 34.9199 25.981 34.9199C26.2251 34.9199 26.4302 34.7138 26.4302 34.4683V30.3071C26.4302 30.0523 26.2251 29.8555 25.981 29.8555C25.7393 29.8529 25.5317 30.0616 25.5317 30.3071Z"
          fill="url(#paint16_linear_25_24110)"
        />
        <path
          d="M22.8148 31.0405V33.7328C22.8148 33.9876 23.0199 34.1844 23.264 34.1844C23.5082 34.1844 23.7133 33.9783 23.7133 33.7328V31.0405C23.7133 30.7857 23.5082 30.5889 23.264 30.5889C23.0199 30.5889 22.8148 30.7857 22.8148 31.0405Z"
          fill="url(#paint17_linear_25_24110)"
        />
        <path
          d="M14.8463 17.8086C14.3682 17.8086 13.9092 17.9982 13.5713 18.3353C13.2333 18.6751 13.0474 19.1267 13.0474 19.6172C13.0474 20.6153 13.8541 21.4259 14.8463 21.4259H17.5241C18.0022 21.4259 18.4612 21.2363 18.7991 20.8991C19.137 20.5594 19.323 20.1077 19.323 19.6172C19.323 18.6192 18.5163 17.8086 17.5241 17.8086H14.8463ZM18.4132 19.6172C18.4132 19.8622 18.319 20.0787 18.15 20.2486C17.981 20.4185 17.7564 20.5133 17.522 20.5133H14.8442C14.3564 20.5133 13.9556 20.1176 13.9556 19.6198C13.9556 19.3748 14.0499 19.1583 14.209 18.9885C14.378 18.8186 14.6026 18.7238 14.837 18.7238H17.5148C18.0197 18.7238 18.4132 19.1267 18.4132 19.6172Z"
          fill="url(#paint18_linear_25_24110)"
        />
        <path
          d="M7.09935 17.8086C6.62128 17.8086 6.16227 17.9982 5.82433 18.3353C5.48639 18.6751 5.30042 19.1267 5.30042 19.6172C5.30042 20.6153 6.10715 21.4259 7.09935 21.4259H9.77714C10.2552 21.4259 10.7142 21.2363 11.0522 20.8991C11.3901 20.5594 11.5761 20.1077 11.5761 19.6172C11.5761 18.6192 10.7693 17.8086 9.77714 17.8086H7.09935ZM10.6684 19.6172C10.6684 19.8622 10.5741 20.0787 10.4051 20.2486C10.2361 20.4185 10.0115 20.5133 9.77714 20.5133H7.09935C6.61149 20.5133 6.2107 20.1176 6.2107 19.6198C6.2107 19.3748 6.30497 19.1583 6.47394 18.9885C6.64292 18.8186 6.86753 18.7238 7.10192 18.7238H9.77971C10.2748 18.7238 10.6684 19.1267 10.6684 19.6172Z"
          fill="url(#paint19_linear_25_24110)"
        />
        <path
          d="M25.5317 17.5369V21.6981C25.5317 21.9529 25.7368 22.1497 25.981 22.1497C26.2251 22.1497 26.4302 21.9436 26.4302 21.6981V17.5369C26.4302 17.2821 26.2251 17.0853 25.981 17.0853C25.7393 17.0755 25.5317 17.2821 25.5317 17.5369Z"
          fill="url(#paint20_linear_25_24110)"
        />
        <path
          d="M22.8148 18.2715V20.9637C22.8148 21.2185 23.0199 21.4154 23.264 21.4154C23.5082 21.4154 23.7133 21.2092 23.7133 20.9637V18.2715C23.7133 18.0166 23.5082 17.8198 23.264 17.8198C23.0126 17.8079 22.8148 18.0166 22.8148 18.2715Z"
          fill="url(#paint21_linear_25_24110)"
        />
        <path
          d="M14.8463 5.04102C14.3682 5.04102 13.919 5.23058 13.5713 5.56776C13.2333 5.90753 13.0474 6.35917 13.0474 6.84966C13.0474 7.84773 13.8541 8.6583 14.8463 8.6583H17.5241C18.0022 8.6583 18.4612 8.46873 18.7991 8.13156C19.137 7.79179 19.323 7.34015 19.323 6.84966C19.323 5.85159 18.5163 5.04102 17.5241 5.04102H14.8463ZM18.4132 6.83982C18.4132 7.07548 18.319 7.3013 18.15 7.47118C17.981 7.64107 17.7564 7.73585 17.522 7.73585H14.8442C14.3564 7.73585 13.9556 7.34015 13.9556 6.84241C13.9556 6.59742 14.0499 6.38092 14.209 6.21104C14.378 6.04116 14.6026 5.94637 14.837 5.94637H17.5148C18.0197 5.95362 18.4132 6.34933 18.4132 6.83982Z"
          fill="url(#paint22_linear_25_24110)"
        />
        <path
          d="M7.09935 5.04102C6.62128 5.04102 6.16227 5.23058 5.82433 5.56776C5.48639 5.90753 5.30042 6.35917 5.30042 6.84966C5.30042 7.84773 6.10715 8.6583 7.09935 8.6583H9.77714C10.2552 8.6583 10.7142 8.46873 11.0522 8.13156C11.3901 7.79179 11.5761 7.34015 11.5761 6.84966C11.5761 5.85159 10.7693 5.04102 9.77714 5.04102H7.09935ZM10.6684 6.83982C10.6684 7.07548 10.5741 7.3013 10.4051 7.47118C10.2361 7.64107 10.0115 7.73585 9.77714 7.73585L7.09935 7.73326C6.61149 7.73326 6.2107 7.33756 6.2107 6.83982C6.2107 6.59483 6.30497 6.37833 6.47394 6.20845C6.64292 6.03857 6.86753 5.94378 7.10192 5.94378H9.77971C10.2748 5.95362 10.6684 6.34933 10.6684 6.83982Z"
          fill="url(#paint23_linear_25_24110)"
        />
        <path
          d="M37.3062 8.1849V5.49266C37.3062 5.23783 37.1011 5.04102 36.8569 5.04102C36.6127 5.04102 36.4077 5.24716 36.4077 5.49266V8.1849C36.4077 8.43973 36.6127 8.63655 36.8569 8.63655C37.1083 8.64639 37.3062 8.43973 37.3062 8.1849Z"
          fill="url(#paint24_linear_25_24110)"
        />
        <path
          d="M34.5892 8.92038V4.75926C34.5892 4.50443 34.3842 4.30762 34.14 4.30762C33.8958 4.30762 33.6908 4.51376 33.6908 4.75926V8.92038C33.6908 9.1752 33.8958 9.37202 34.14 9.37202C34.3842 9.37202 34.5892 9.1752 34.5892 8.92038Z"
          fill="url(#paint25_linear_25_24110)"
        />
        <path
          d="M31.4236 4.30469C31.1701 4.30469 30.9744 4.51083 30.9744 4.75633V8.91745C30.9744 9.17227 31.1794 9.36909 31.4236 9.36909C31.6678 9.36909 31.8728 9.16295 31.8728 8.91745V4.75633C31.8728 4.51342 31.6678 4.30469 31.4236 4.30469Z"
          fill="url(#paint26_linear_25_24110)"
        />
        <path
          d="M28.2482 4.75633V8.91745C28.2482 9.17227 28.4532 9.36909 28.6974 9.36909C28.9416 9.36909 29.1466 9.16295 29.1466 8.91745V4.75633C29.1466 4.5015 28.9416 4.30469 28.6974 4.30469C28.4532 4.30469 28.2482 4.51342 28.2482 4.75633Z"
          fill="url(#paint27_linear_25_24110)"
        />
        <path
          d="M25.5317 4.75633V8.91745C25.5317 9.17227 25.7368 9.36909 25.981 9.36909C26.2251 9.36909 26.4302 9.16295 26.4302 8.91745V4.75633C26.4302 4.5015 26.2251 4.30469 25.981 4.30469C25.7368 4.30469 25.5317 4.51342 25.5317 4.75633Z"
          fill="url(#paint28_linear_25_24110)"
        />
        <path
          d="M22.8148 5.49266V8.1849C22.8148 8.43973 23.0199 8.63655 23.264 8.63655C23.5082 8.63655 23.7133 8.43041 23.7133 8.1849V5.49266C23.7133 5.23783 23.5082 5.04102 23.264 5.04102C23.0199 5.04102 22.8148 5.23783 22.8148 5.49266Z"
          fill="url(#paint29_linear_25_24110)"
        />
        <path
          d="M40.5372 41.4563C40.5661 41.4661 40.5928 41.4661 40.6217 41.4661C40.6505 41.4661 40.6773 41.4661 40.7062 41.4563L41.1286 41.3812C47.6005 40.1941 52.3766 34.7702 52.7439 28.1789C52.7634 27.9241 52.5651 27.7081 52.3142 27.6983C52.051 27.6786 51.8459 27.878 51.8362 28.1302C51.4884 34.2994 47.021 39.383 40.9622 40.4857L40.6243 40.5514L40.2863 40.4857C33.9741 39.3374 29.3933 33.8188 29.3933 27.3683L29.3907 16.8216L40.6222 12.6869L51.8537 16.8216V23.5833C51.8537 23.8381 52.0587 24.0349 52.3029 24.0349C52.5471 24.0349 52.7521 23.8288 52.7521 23.5833V16.501C52.7521 16.3114 52.6316 16.1343 52.4528 16.069L40.7628 11.7743C40.6588 11.7354 40.548 11.7354 40.4537 11.7743L28.7638 16.069C28.585 16.1348 28.4645 16.3047 28.4645 16.501V27.3585C28.4645 34.2512 33.3641 40.1459 40.0962 41.3719L40.5377 41.4563H40.5372Z"
          fill="url(#paint30_linear_25_24110)"
        />
        <path
          d="M42.9158 24.7136C42.9158 23.4415 41.8844 22.4072 40.6218 22.4072C39.3591 22.4072 38.3278 23.4441 38.3278 24.7136C38.3278 25.4009 38.6369 26.0613 39.1608 26.4834L38.6466 29.5522C38.6271 29.6832 38.6662 29.8169 38.7507 29.9189C38.8352 30.0235 38.9655 30.0789 39.0984 30.0789H42.1507C42.2811 30.0789 42.414 30.023 42.4985 29.9189C42.583 29.8148 42.619 29.6832 42.6025 29.5522L42.0884 26.4834C42.5979 26.0489 42.9168 25.4004 42.9168 24.7136H42.9158ZM41.3533 25.8888C41.1941 25.9836 41.1096 26.1706 41.1385 26.3503L41.6067 29.1762H39.6316L40.0999 26.3503C40.1288 26.1706 40.0443 25.9836 39.8851 25.8888C39.4817 25.6438 39.2283 25.1922 39.2283 24.7115C39.2283 23.9393 39.8464 23.3178 40.6145 23.3178C41.3826 23.3178 42.0008 23.9393 42.0008 24.7115C42.008 25.1849 41.7546 25.6366 41.3538 25.8888H41.3533Z"
          fill="url(#paint31_linear_25_24110)"
        />
        <path
          d="M49.1075 8.11918H54.4564V10.4085C53.4544 10.6146 52.7058 11.5106 52.7058 12.574C52.7058 13.7973 53.6986 14.7882 54.9081 14.7882C56.1177 14.7882 57.1104 13.7901 57.1104 12.574C57.1104 11.5106 56.3619 10.6146 55.3599 10.4085V7.6577C55.3599 7.40287 55.1549 7.20605 54.9107 7.20605H49.1126C48.8592 7.20605 48.6634 7.41219 48.6634 7.6577C48.6588 7.92236 48.8638 8.11918 49.1075 8.11918ZM56.2069 12.5838C56.2069 13.3001 55.6273 13.8926 54.9051 13.8926C54.1828 13.8926 53.6033 13.31 53.6033 12.5838C53.6033 11.8577 54.1756 11.2947 54.8783 11.2848C54.8881 11.2848 54.8978 11.2947 54.9071 11.2947C54.9164 11.2947 54.9267 11.2848 54.936 11.2848C55.6361 11.2921 56.2064 11.8773 56.2064 12.5838H56.2069Z"
          fill="url(#paint32_linear_25_24110)"
        />
        <path
          d="M55.0668 39.3467C53.85 39.3467 52.8645 40.3447 52.8645 41.5609C52.8645 42.6242 53.613 43.5202 54.615 43.7264V46.0157H49.0317C48.7783 46.0157 48.5825 46.2218 48.5825 46.4673C48.5825 46.7128 48.7876 46.9189 49.0317 46.9189H55.0637C55.3172 46.9189 55.5129 46.7128 55.5129 46.4673V43.7165C56.5149 43.5104 57.2634 42.6144 57.2634 41.551C57.2681 40.337 56.2831 39.3467 55.0658 39.3467H55.0668ZM55.0957 42.8599C55.0859 42.8599 55.0761 42.85 55.0668 42.85C55.0575 42.85 55.0472 42.8599 55.038 42.8599C54.3353 42.8402 53.7629 42.2673 53.7629 41.5609C53.7629 40.8544 54.3425 40.252 55.0648 40.252C55.787 40.252 56.3666 40.8347 56.3666 41.5609C56.3691 42.2673 55.7989 42.85 55.0962 42.8599H55.0957Z"
          fill="url(#paint33_linear_25_24110)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_25_24110"
          x1="45.6332"
          y1="15.7842"
          x2="45.6332"
          y2="37.5931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_25_24110"
          x1="0.481442"
          y1="51.0967"
          x2="0.481442"
          y2="52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_25_24110"
          x1="26.8969"
          y1="0"
          x2="26.8969"
          y2="51.999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_25_24110"
          x1="55.2553"
          y1="51.0967"
          x2="55.2553"
          y2="52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_25_24110"
          x1="58.4171"
          y1="51.0967"
          x2="58.4171"
          y2="52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_25_24110"
          x1="16.1852"
          y1="43.3594"
          x2="16.1852"
          y2="46.9767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_25_24110"
          x1="8.43824"
          y1="43.3594"
          x2="8.43824"
          y2="46.9767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_25_24110"
          x1="36.8477"
          y1="43.3691"
          x2="36.8477"
          y2="46.965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_25_24110"
          x1="34.1307"
          y1="42.6328"
          x2="34.1307"
          y2="47.6972"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_25_24110"
          x1="31.4236"
          y1="42.6338"
          x2="31.4236"
          y2="47.6982"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_25_24110"
          x1="28.6974"
          y1="42.6328"
          x2="28.6974"
          y2="47.6972"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_25_24110"
          x1="25.981"
          y1="42.6328"
          x2="25.981"
          y2="47.6972"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_25_24110"
          x1="23.264"
          y1="43.3691"
          x2="23.264"
          y2="46.965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_25_24110"
          x1="16.1852"
          y1="30.5889"
          x2="16.1852"
          y2="34.2061"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_25_24110"
          x1="8.43824"
          y1="30.5889"
          x2="8.43824"
          y2="34.2061"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_25_24110"
          x1="28.6974"
          y1="33.291"
          x2="28.6974"
          y2="34.9301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_25_24110"
          x1="25.981"
          y1="29.8555"
          x2="25.981"
          y2="34.9199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_25_24110"
          x1="23.264"
          y1="30.5889"
          x2="23.264"
          y2="34.1844"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_25_24110"
          x1="16.1852"
          y1="17.8086"
          x2="16.1852"
          y2="21.4259"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_25_24110"
          x1="8.43824"
          y1="17.8086"
          x2="8.43824"
          y2="21.4259"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_25_24110"
          x1="25.981"
          y1="17.085"
          x2="25.981"
          y2="22.1497"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_25_24110"
          x1="23.264"
          y1="17.8193"
          x2="23.264"
          y2="21.4154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_25_24110"
          x1="16.1852"
          y1="5.04102"
          x2="16.1852"
          y2="8.6583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_25_24110"
          x1="8.43824"
          y1="5.04102"
          x2="8.43824"
          y2="8.6583"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_25_24110"
          x1="36.8569"
          y1="5.04102"
          x2="36.8569"
          y2="8.63688"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_25_24110"
          x1="34.14"
          y1="4.30762"
          x2="34.14"
          y2="9.37202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_25_24110"
          x1="31.4236"
          y1="4.30469"
          x2="31.4236"
          y2="9.36909"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_25_24110"
          x1="28.6974"
          y1="4.30469"
          x2="28.6974"
          y2="9.36909"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_25_24110"
          x1="25.981"
          y1="4.30469"
          x2="25.981"
          y2="9.36909"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_25_24110"
          x1="23.264"
          y1="5.04102"
          x2="23.264"
          y2="8.63655"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_25_24110"
          x1="40.6083"
          y1="11.7451"
          x2="40.6083"
          y2="41.4661"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_25_24110"
          x1="40.6223"
          y1="22.4072"
          x2="40.6223"
          y2="30.0789"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_25_24110"
          x1="52.8869"
          y1="7.20605"
          x2="52.8869"
          y2="14.7882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_25_24110"
          x1="52.923"
          y1="39.3467"
          x2="52.923"
          y2="46.9189"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EF4F34" />
        </linearGradient>
        <clipPath id="clip0_25_24110">
          <rect width="59" height="52" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
